import Cookies from 'universal-cookie';
import { getGaClientId } from '@/utils/ga-client-id';

/**
 * The register payload's `meta.cookies` attribution block (Ember's
 * `_referrerRequestParams`) — the field names are a revenue-attribution
 * contract. Absent cookies are sent as `''`, which the server stores
 * identically to Ember's omitted keys. Snowplow is only requested on the
 * final register call, matching Ember.
 */
export type ReferrerRequestParams = {
  referrer: string;
  ajs_id: string;
  ga_client_id: string;
  first_touch_referrer: string;
  last_touch_referrer: string;
  first_touch_domain: string;
  last_touch_domain: string;
  snowplow?: string;
};

export function getReferrerRequestParams(options: { includeSnowplow: true }): Required<ReferrerRequestParams>;
export function getReferrerRequestParams(options?: { includeSnowplow?: boolean }): ReferrerRequestParams;
export function getReferrerRequestParams({ includeSnowplow = false } = {}): ReferrerRequestParams {
  const cookies = new Cookies();
  const firstTouchReferrer = cookies.get<string | undefined>('cioFT') ?? '';
  const lastTouchReferrer = cookies.get<string | undefined>('cioLT') ?? '';

  const params: ReferrerRequestParams = {
    referrer: document.referrer,
    ajs_id: cookies.get<string | undefined>('ajs_anonymous_id') ?? '',
    ga_client_id: getGaClientId(),
    first_touch_referrer: firstTouchReferrer,
    last_touch_referrer: lastTouchReferrer,
    first_touch_domain: extractDomain(firstTouchReferrer),
    last_touch_domain: extractDomain(lastTouchReferrer),
  };

  if (includeSnowplow) {
    params.snowplow = cookies.get<string | undefined>('sp') ?? '';
  }

  return params;
}

// Ember's `_extractDomain`: lowercased hostname, tolerating bare hosts and
// scheme-less values without throwing.
export function extractDomain(url: string | undefined): string {
  if (url == null || url === '') {
    return '';
  }

  let hostname = url.includes('//') ? url.split('/')[2] : url.split('/')[0];

  // Remove a port number and any query params.
  hostname = hostname.split(':')[0];
  hostname = hostname.split('?')[0];

  return hostname.toLowerCase();
}
